(() => {
  const STACK_SELECTOR = '[data-random-fabrics]';
  const SWATCH_SELECTOR = '[data-fabric-swatch]';

  const shuffle = (items) => {
    const copy = items.slice();
    for (let index = copy.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [copy[index], copy[randomIndex]] = [copy[randomIndex], copy[index]];
    }
    return copy;
  };

  const getImageSource = (product) => {
    if (!product) return '';

    if (Array.isArray(product.images) && product.images.length) {
      const firstImage = product.images[0];
      if (typeof firstImage === 'string') return firstImage;
      if (firstImage && typeof firstImage === 'object') {
        return firstImage.src || firstImage.url || '';
      }
    }

    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && typeof product.featured_image === 'object') {
      return product.featured_image.src || product.featured_image.url || '';
    }

    return '';
  };

  const getProducts = async (root, handle, page) => {
    const url = `${root}collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`;
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error(`Fabric request failed: ${response.status}`);
    }

    const payload = await response.json();
    return Array.isArray(payload.products) ? payload.products : [];
  };

  const validProducts = (products) => products.filter((product) => {
    return product && product.handle && getImageSource(product);
  });

  const loadSwatches = async (stack) => {
    if (!stack || stack.dataset.randomFabricsStatus === 'loading' || stack.dataset.randomFabricsStatus === 'loaded') return;

    const handle = stack.dataset.collectionHandle;
    if (!handle) return;

    stack.dataset.randomFabricsStatus = 'loading';

    const configuredRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    const root = configuredRoot || '/';
    const productCount = Number.parseInt(stack.dataset.productCount, 10) || 250;
    const maximumPage = Math.max(1, Math.ceil(productCount / 250));
    const randomPage = 1 + Math.floor(Math.random() * maximumPage);

    try {
      let products = validProducts(await getProducts(root, handle, randomPage));

      if (products.length < 6 && randomPage !== 1) {
        const fallbackProducts = validProducts(await getProducts(root, handle, 1));
        const existingHandles = new Set(products.map((product) => product.handle));

        fallbackProducts.forEach((product) => {
          if (!existingHandles.has(product.handle)) {
            existingHandles.add(product.handle);
            products.push(product);
          }
        });
      }

      const chosenProducts = shuffle(products).slice(0, 6);
      let loadedCount = 0;

      stack.querySelectorAll(SWATCH_SELECTOR).forEach((swatch, index) => {
        const product = chosenProducts[index];
        const image = swatch.querySelector('img');
        if (!product || !image) return;

        const source = getImageSource(product);
        if (!source) return;

        const markLoaded = () => swatch.classList.add('is-loaded');
        image.addEventListener('load', markLoaded, { once: true });
        image.src = source;
        image.alt = product.title || 'Fabric';
        image.decoding = 'async';
        swatch.href = `${root}products/${encodeURIComponent(product.handle)}`;
        swatch.setAttribute('aria-label', `View ${product.title || 'fabric'}`);
        loadedCount += 1;

        if (image.complete) markLoaded();
      });

      stack.dataset.randomFabricsStatus = loadedCount ? 'loaded' : 'empty';
    } catch (error) {
      stack.dataset.randomFabricsStatus = 'error';
      console.warn('Random fabric swatches could not be loaded.', error);
    }
  };

  const initialize = (root = document) => {
    if (root.matches && root.matches(STACK_SELECTOR)) loadSwatches(root);
    if (root.querySelectorAll) root.querySelectorAll(STACK_SELECTOR).forEach(loadSwatches);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();